/**
 * 员工管理-详情
 */
const SataffDescRouter = {
  path: '/staff',
  component: () => import('@/views/layout'),
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [
    {
      path: 'manage/new_add',
      name: 'new_employees',
      hidden: true,
      component: () => import('@/views/emp_manage/new_employees'),
      meta: {
        title: '录入新员工'
      }
    },
    {
      path: 'manage/edit/:id',
      name: 'employees_edit',
      hidden: true,
      component: () => import('@/views/emp_manage/new_employees'),
      meta: {
        title: '编辑员工'
      }
    },
    {
      path: 'manage/detail/:id',
      name: 'employee_details',
      hidden: true,
      component: () => import('@/views/emp_manage/employee_details'),
      meta: {
        title: '员工详情'
      }
    },
    {
      path: 'manage/desc/:id',
      name: 'introducer_desc',
      hidden: true,
      component: () => import('@/views/emp_manage/introducer_desc'),
      meta: {
        title: '员工详情'
      }
    },
    {
      path: 'manage/audit_desc/:id',
      name: 'audit_staff',
      hidden: true,
      component: () => import('@/views/emp_manage/audit_staff'),
      meta: {
        title: '审核员工'
      }
    },
    // 审核中的状况
    {
      path: 'manage/audit_staff_read_only/:id',
      name: 'audit_staff_read_only',
      hidden: true,
      component: () => import('@/views/emp_manage/audit_staff_read_only'),
      meta: {
        title: '员工详情'
      }
    },
    {
      path: 'interview/detail/:id',
      name: 'interview_details',
      hidden: true,
      component: () => import('@/views/Interviewers/interview_details'),
      meta: {
        title: '申请面试人员详情'
      }
    },

    // 下面的是离职列表

    {
      path: 'separation/apply/detail/:id',
      name: 'staff_apply_details',
      hidden: true,
      component: () => import('@/views/separation_list/details/apply_details'),
      meta: {
        title: '详情'
      }
    },
    {
      path: 'separation/join/detail/:id',
      name: 'staff_join_details',
      hidden: true,
      component: () => import('@/views/separation_list/details/join_details'),
      meta: {
        title: '详情'
      }
    },
    {
      path: 'separation/leave/detail/:id',
      name: 'staff_leave_details',
      hidden: true,
      component: () => import('@/views/separation_list/details/leave_details'),
      meta: {
        title: '详情'
      }
    },
    {
      path: 'separation/reject/detail/:id',
      name: 'staff_reject_details',
      hidden: true,
      component: () => import('@/views/separation_list/details/reject_details'),
      meta: {
        title: '详情'
      }
    },

    // 下面是办公室员工列表

    {
      path: 'office/new_add',
      name: 'office_new_employee',
      hidden: true,
      component: () => import('@/views/office_list/new_employee'),
      meta: {
        title: '办公室人员录入'
      }
    },
    {
      path: 'office/new_edit/:id',
      name: 'office_edit_employee',
      hidden: true,
      component: () => import('@/views/office_list/new_employee'),
      meta: {
        title: '办公室人员编辑'
      }
    },
    {
      path: 'office/desc/:id',
      name: 'office_desc',
      hidden: true,
      component: () => import('@/views/office_list/office_desc'),
      meta: {
        title: '办公室人员详情'
      }
    },

    {
      path: 'adjust/desc',
      name: 'adjust_pages_desc',
      hidden: true,
      component: () => import('@/views/emp_manage/adjustpages/desc'),
      meta: {
        title: '调级详情'
      }
    },
    {
      path: 'adjust/approval/:id',
      name: 'adjust_pages_approval',
      hidden: true,
      component: () => import('@/views/emp_manage/adjustpages/desc'),
      meta: {
        title: '调级审批'
      }
    },
    {
      path: 'probation/desc',
      name: 'probation_pages_desc',
      hidden: true,
      component: () => import('@/views/emp_manage/probation/desc'),
      meta: {
        title: '试用期详情'
      }
    },
    {
      path: 'probation/approval/:id',
      name: 'probation_pages_approval',
      hidden: true,
      component: () => import('@/views/emp_manage/probation/desc'),
      meta: {
        title: '试用期审批'
      }
    },
    {
      path: 'leave/desc/:id',
      name: 'employees_leave_desc',
      hidden: true,
      component: () => import('@/views/employees_leave/pages/desc'),
      meta: {
        title: '详情'
      }
    },
    {
      path: 'leave/adesc/:id',
      name: 'employees_leave_approvaldesc',
      hidden: true,
      component: () => import('@/views/employees_leave/pages/approvaldesc'),
      meta: {
        title: '详情'
      }
    },
    {
      path: 'leave/application',
      name: 'employees_leave_application',
      hidden: true,
      component: () => import('@/views/employees_leave/pages/application'),
      meta: {
        title: '详情'
      }
    }

  ]
}

export default SataffDescRouter
